import { render, staticRenderFns } from "./main-search.vue?vue&type=template&id=2e4bd91f&scoped=true&"
import script from "./main-search.vue?vue&type=script&lang=ts&"
export * from "./main-search.vue?vue&type=script&lang=ts&"
import style0 from "./main-search.vue?vue&type=style&index=0&id=2e4bd91f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4bd91f",
  null
  
)

export default component.exports